import { activityLogService } from "../services/activityLog.service";

import {
  activityLogConstants,
  activityLog_nameSpace,
} from "../constants/activityLog.constants";
import { createRequestBody } from "../factories/activityLogStatements.factory";
import { message } from "../../../constants/app.constants";
import { show as showAlert } from "../../Notifications/actions/alert.actions";
import { appUtils } from "../../../utils/app.utils";

export const getActivityLog = (requestParams) => {
  return async (dispatch) => {
    const requestObject = createRequestBody(requestParams);

    dispatch(request(requestParams));
    try {
      const response = await activityLogService.getActivityLog(requestObject);

      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        showAlert(
          "danger",
          "Failed to get activity log statement",
          error ? error.message : message.GENERIC_ERROR
        )
      );
    }
  };

  function request(request) {
    return {
      type: activityLogConstants[`GET_${activityLog_nameSpace}_REQUEST`],
      request,
    };
  }
  function success(response) {
    return {
      type: activityLogConstants[`GET_${activityLog_nameSpace}_SUCCESS`],
      response,
    };
  }
  function failure(error) {
    return {
      type: activityLogConstants[`GET_${activityLog_nameSpace}_FAILURE`],
      error,
    };
  }
};

export const downloadCsvActivityLog = (requestParams) => {
  return async (dispatch) => {
    const requestObject = createRequestBody(requestParams);

    dispatch(request(requestParams));
    try {
      const response = await activityLogService.getActivityLog(requestObject);
      if (response) {
        dispatch(success(response));

        if (requestObject.fileType === "CSV") {
          appUtils.csvDownloadFile(response);
        } else {
          appUtils.pdfDownloadFile(response);
        }
      }
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        showAlert(
          "danger",
          "Failed to download activity log statement",
          error ? error.message : message.GENERIC_ERROR
        )
      );
    }
  };

  function request(request) {
    return {
      type: `DOWNLOADCSV_${activityLog_nameSpace}_REQUEST`,
      request,
    };
  }
  function success(response) {
    return {
      type: `DOWNLOADCSV_${activityLog_nameSpace}_SUCCESS`,
      response,
    };
  }
  function failure(error) {
    return {
      type: `DOWNLOADCSV_${activityLog_nameSpace}_FAILURE`,
      error,
    };
  }
};

export const downloadPdfActivityLog = (requestParams) => {
  return async (dispatch) => {
    const requestObject = createRequestBody(requestParams);

    dispatch(request(requestParams));
    try {
      const response = await activityLogService.getActivityLog(requestObject);
      if (response) {
        dispatch(success(response));

        if (requestObject.fileType === "PDF") {
          appUtils.pdfDownloadFile(response);
        } else {
          appUtils.csvDownloadFile(response);
        }
      }
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        showAlert(
          "danger",
          "Failed to download activity log statement",
          error ? error.message : message.GENERIC_ERROR
        )
      );
    }
  };

  function request(request) {
    return {
      type: `DOWNLOADPDF_${activityLog_nameSpace}_REQUEST`,
      request,
    };
  }
  function success(response) {
    return {
      type: `DOWNLOADPDF_${activityLog_nameSpace}_SUCCESS`,
      response,
    };
  }
  function failure(error) {
    return {
      type: `DOWNLOADPDF_${activityLog_nameSpace}_FAILURE`,
      error,
    };
  }
};

export const resetStatements = () => {
  return { type: activityLogConstants[`GET_${activityLog_nameSpace}_RESET`] };
};

export const csvResetActivityLogDownload = () => {
  return { type: `DOWNLOADCSV_${activityLog_nameSpace}_RESET` };
};

export const pdfResetActivtyLogDownload = () => {
  return { type: `DOWNLOADPDF_${activityLog_nameSpace}_RESET` };
};
